import React, { useState } from 'react';
import { Link } from 'react-router-dom';

export const ProductCard = ({ product }) => {
  const [imgError, setImgError] = useState(false);
  
  const handleImageError = () => {
    setImgError(true);
  };
  
  return (
    <Link
      to={`/product/${product.id}`}
      state={{ product }}
      className="product-card group block"
      data-testid={`product-card-${product.id}`}
    >
      <div className="product-image-container mb-4 relative overflow-hidden">
        {!imgError ? (
          <img
            src={product.images?.[0] || '/placeholder.jpg'}
            alt={product.name}
            className="product-image w-full h-full"
            onError={handleImageError}
            loading="lazy"
            decoding="async"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center bg-cream-200 text-leather-400">
            <span className="text-sm">Image unavailable</span>
          </div>
        )}
        {product.featured && (
          <span className="absolute top-4 left-4 bg-gold-500 text-leather-900 px-3 py-1 text-xs tracking-widest uppercase font-semibold shadow-lg">
            Featured
          </span>
        )}
        {product.subcategory && (
          <span className="absolute top-4 right-4 bg-leather-900/80 text-white px-2 py-1 text-xs tracking-wide uppercase backdrop-blur-sm">
            {product.subcategory}
          </span>
        )}
      </div>
      <div className="space-y-2 px-2 pb-4">
        <p className="text-xs tracking-widest uppercase text-leather-500 font-semibold">
          {product.category?.replace('_', ' ')}
        </p>
        <h3 className="font-heading text-lg leading-tight text-leather-900 group-hover:text-gold-600 transition-colors line-clamp-2">
          {product.name}
        </h3>
        <div className="flex items-center justify-between">
          <p className="text-leather-900 font-bold text-xl">{product.price?.toLocaleString()} <span className="text-sm font-normal">JMD</span></p>
          {product.stock > 0 ? (
            <span className="text-xs text-green-600 font-medium">In Stock</span>
          ) : (
            <span className="text-xs text-red-500 font-medium">Out of Stock</span>
          )}
        </div>
      </div>
    </Link>
  );
};
